export const canAddForOtherUsers = (permissions) => {
    return (!!permissions.add_for_other_users || !!permissions.add_user_prop);
}

export const canEditOtherUsers = (permissions) => {
    return (!!permissions.edit_all || !!permissions.edit_user_prop);
}

export const canChangeOtherUsers = (permissions, isEditing) => {
    return (isEditing)
        ? canEditOtherUsers(permissions)
        : canAddForOtherUsers(permissions)
}
